const priorityColorClass = {
  L: 'priority--low',
  M: 'priority--medium',
  H: 'priority--high',
};

export { priorityColorClass };
